import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.mjs";import{__require as e}from"../ClientBuilder.mjs";var m=r(e());export{m as default};
